<template>
  <transition
    :name="transition"
    mode="in-out"
    appear
    :appear-active-class="enterClass"
    :enter-active-class="enterClass"
    :leave-active-class="leaveClass"
  >
    <div v-if="show">
      <div class="alert-modal-background" @click="deactive"></div>
      <div class="alert-modal-card" :style="style">
        <header class="alert-modal-card-head">
          <p class="alert-modal-card-title">{{ title }}</p>
        </header>
        <div class="alert-modal-card-rap">
          <section class="alert-modal-card-body" :class="body_class">
            <div>{{content}}</div>
          </section>
          <section class="alert-modal-card-bottom">
            <button class="btn-ok" @click="ok">はい</button>
            <button v-if="(ok_cb != null)" class="btn-ng" @click="cancel">いいえ</button>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AlertModal',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    content: {
      type: String,
    },
    ok_cb: {
      type: Function,
    },
    ng_cb: {
      type: Function,
    },
    type: {
      type: String,
    },
    visible: Boolean,
    transition: {
      type: String,
      default: 'fade',
    }
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      show: this.visible,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    title () {
      if (this.type === 'alert') {
        return 'システムメッセージ';
      } else if (this.type === 'warning') {
        return 'Warning';
      }
      return 'Information';
    },
    body_class () {
      if (this.type === 'alert') {
        return 'alert-body-class';
      } else if (this.type === 'warning') {
        return 'warning-body-class';
      }
      return 'info-body-class';
    },
    style () {
      return '';
    },
    enterClass () {
      return `${this.transition}In`;
    },

    leaveClass () {
      return `${this.transition}Out`;
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    this.$lib._$id('alert_layer').appendChild(this.$el);
    this.$lib._$id('alert_layer').style.display = 'block';
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    ok () {
      if (this.ok_cb !== null) {
        this.ok_cb();
      }
      this.remove();
    },

    cancel () {
      if (this.ng_cb !== null) {
        this.ng_cb();
      }
      this.remove();
    },

    active () {
      this.show = true;
    },

    deactive () {
      this.show = false;
      this.remove();
    },

    remove () {
      this.$lib._$id('alert_layer').removeChild(this.$el);
      this.$lib._$id('alert_layer').style.display = 'none';
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
    visible (val) {
      this.show = val;
    }
  },
};
</script>

<style lang="scss">
.alert-modal-card {
  margin-top: calc(50vh - 150px);

  .alert-modal-card-head, .alert-modal-card-bottom {
    width: 50%;
    margin: 0 auto;
    color: #fefefe;
  }
  .alert-modal-card-body {
    border-top: 1px solid #49b0ec;
    border-bottom: 1px solid #49b0ec;
    color: #fefefe;
    padding: 20px 0;
    div {
      width: 45%;
      height: 100px;
      margin: 0 auto;
      white-space: pre;
    }
  }
  .alert-body-class {
    border-top: 1px solid #6d6d6d;
    border-bottom: 1px solid #6d6d6d;
    background: #6d6d6d;
  }
  .warning-body-class {
    border-top: 1px solid #ffd22e;
    border-bottom: 1px solid #ffd22e;
    background: #6d6d6d;
  }
  .alert-modal-card-title {
    font-size: 28px;
    margin: 0;
    color: #6d6d6d;
  }
  .alert-modal-card-bottom {
    padding: 10px 0;
    text-align: center;
    button {
      border: none;
      color: #fefefe;
      width: 150px;
      text-align: center;
      padding: 10px;
      margin-right: 10px;
      font-size: 18px;
    }
    button:last-child {
      margin-right: 0px;
    }
    .btn-ok {
      background: rgb(95, 135, 253);
      color: #fefefe;
    }
    .btn-ng {
      background: rgb(253, 95, 108);
      color: #fefefe;
    }
    .btn-ok:hover {
      background: #96adf3;
    }
    .btn-ng:hover {
      background: #fb808a;
    }
  }
}
</style>
